import script from "./actionIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./actionIcons.vue?vue&type=script&setup=true&lang=js"

import "./actionIcons.vue?vue&type=style&index=0&id=8dc2497e&lang=scss"

const __exports__ = script;

export default __exports__